import { render, staticRenderFns } from "./GrantWizardTab.vue?vue&type=template&id=bb44e064&"
import script from "./GrantWizardTab.vue?vue&type=script&lang=js&"
export * from "./GrantWizardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports